<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">
            <a-config-provider :locale="currentLocale">
                <a-card>
                    <template #title>
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <span>Documentos</span>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>Listar</a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>
                    <template #extra>
                        <a-button :icon="h(PlusOutlined)" @click="newDoc">Novo Documento</a-button>
                    </template>
                    <a-table :columns="columns" :data-source="dataSource" bordered>
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.dataIndex === 'data'">
                                {{ new Date(record.data).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) }}
                            </template>
                            <template v-if="column.key === 'acao'">
                                <a-button type="primary" shape="circle" @click="updateDoc(record);">
                                    <template #icon>
                                        <a-tooltip>
                                            <template #title>Alterar</template>
                                            <FormOutlined />
                                        </a-tooltip>
                                    </template>
                                </a-button>
                                <a-button type="primary" danger shape="circle" @click="deleteDoc(record);">
                                    <template #icon>
                                        <a-tooltip>
                                            <template #title>Excluir</template>
                                            <DeleteOutlined />
                                        </a-tooltip>
                                    </template>
                                </a-button>
                            </template>
                        </template>
                    </a-table>
                </a-card>
            </a-config-provider>
        </a-spin>
    </div>
</template>
<script setup>
import { ref, h, onMounted } from 'vue';
import { PlusOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';
import { notification } from 'ant-design-vue';
import { openNotification } from '../../../utils/utilities';

const dataSource = ref();
const currentLocale = ref(ptBR);
const spinning = ref(true);

const routes = {
    get : '/api/docs',
    create : '/docs/listar/create'
}

const columns = ref(
    [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 150,
        },

        {
            title: 'Documento',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        },
        {
            title: 'Ação',
            key: 'acao',
            width: 50,
        }
    ]
);


onMounted(async () => {
    load();
});

const load = async () => {
    try {
        const response = await window.axios.get(routes.get);
        dataSource.value = response.data.data;
        spinning.value = false;
    } catch (error) {
        spinning.value = false;
    }

}
const updateDoc = (data) => {
    window.location.href = `/docs/listar/${data.id}/edit`;
}

const newDoc = () => {
    window.location.href = routes.create;
}

const deleteDoc = async (data) => {
    try {

        const formData = new FormData();
	    formData.append("_method", "DELETE");
        const response =  await window.axios.post(`/docs/listar/${data.id}`, formData);
        spinning.value = false;
        openNotification('success', 'Excluído com Sucesso')
	load();
    } catch (error) {
        spinning.value = false;
	console.log(error)
    }
}
</script>

<style scoped>
.anticon {
    vertical-align: 2px !important;
}
</style>
